module.exports = __webpack_public_path__ + "static/media/PIC.1e6fd9db.png";